import { PayloadAction, ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { IBlog } from "src/@types/blog";
import { getBlogCurrentPostAsync } from "./actions";
import { CurrentBlogState } from "./slice";

type ActionReducerMapBuilderWithCurrentBlogState =
  ActionReducerMapBuilder<CurrentBlogState>;

export const getBlogCurrentPostReducer = (
  builder: ActionReducerMapBuilderWithCurrentBlogState
) => {
  builder.addCase(getBlogCurrentPostAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(
    getBlogCurrentPostAsync.fulfilled,
    (state, actions: PayloadAction<IBlog>) => {
      state.isLoading = false;
      state.post = actions.payload;
    }
  );

  builder.addCase(getBlogCurrentPostAsync.rejected, (state) => {
    state.isLoading = false;
    state.post = null;
  });
};
